import React from "react";

const Tabs = ({
  tabs,
  activeTab,
  onChange,
  onDisabledTabClick,
  className = "",
}) => {
  return (
    <div className={`border-b border-slate-200 ${className}`}>
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isDisabled = Boolean(tab.disabled);
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => {
                if (isDisabled) {
                  onDisabledTabClick?.(tab);
                  return;
                }
                onChange(tab.id);
              }}
              tabIndex={0}
              className={[
                "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-semibold transition",
                isActive
                  ? "border-[#4f46e5] text-[#4f46e5]"
                  : isDisabled
                    ? "cursor-not-allowed border-transparent text-slate-300"
                    : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700",
              ]
                .filter(Boolean)
                .join(" ")}
              aria-current={isActive ? "page" : undefined}
              aria-disabled={isDisabled ? "true" : undefined}
            >
              {tab.icon && (
                <span className="mr-2 inline-block">{tab.icon}</span>
              )}
              {tab.label}
              {tab.badge && (
                <span
                  className={[
                    "ml-2 inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
                    isActive
                      ? "bg-indigo-100 text-indigo-600"
                      : "bg-slate-100 text-slate-600",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  {tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default Tabs;
